import { render } from "./EditRestaurantView.vue?vue&type=template&id=0f1890e6"
import script from "./EditRestaurantView.vue?vue&type=script&lang=js"
export * from "./EditRestaurantView.vue?vue&type=script&lang=js"

import "./EditRestaurantView.vue?vue&type=style&index=0&id=0f1890e6&lang=css"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__